import { onDocumentLoaded } from "@plaudit/frontend-apis";

onDocumentLoaded(document => {
	for (const form of document.querySelectorAll<HTMLFormElement>("form.region-form")) {
		form.querySelector<HTMLSelectElement>("select[name='msa-selected-region']")?.addEventListener('change', () => form.requestSubmit());
	}

	let lastRegion: string|undefined|null = undefined;

	function updateBodyRegionClass(region: string | null | undefined) {
		// Remove all existing region classes
		const bodyClasses = document.body.classList;
		for (let i = bodyClasses.length - 1; i >= 0; i--) {
			const className = bodyClasses[i];
			if (className.startsWith('region-')) {
				bodyClasses.remove(className);
			}
		}
		
		// Add new region class if region exists
		if (region) {
			bodyClasses.add('region-' + region);
			bodyClasses.add('has-region-selected');
		} else {
			bodyClasses.remove('has-region-selected');
		}
	}

	const cookieRegion = getCookie("plaudit_msa_region_locked_products_region");
	if (cookieRegion) {
		const region = localStorage.getItem("msa/region-locked-products/region");
		localStorage.setItem("msa/region-locked-products/region", cookieRegion);
		if (region !== null && region !== cookieRegion) {
			document.dispatchEvent(new CustomEvent("msa/region-locked-products/region-update", {detail: {onLoad: true}}));
		}
		updateBodyRegionClass(cookieRegion);
	} else {
		// Check localStorage as fallback
		const localStorageRegion = localStorage.getItem("msa/region-locked-products/region");
		updateBodyRegionClass(localStorageRegion);
	}
	lastRegion = cookieRegion;
	
	document.addEventListener('visibilitychange', () => {
		const localStorageRegion = localStorage.getItem("msa/region-locked-products/region");
		if (localStorageRegion && lastRegion !== localStorageRegion) {
			lastRegion = localStorageRegion;
			updateBodyRegionClass(localStorageRegion);
			document.dispatchEvent(new CustomEvent("msa/region-locked-products/region-update", {detail: {onLoad: false}}));
		}
	});
	
	// Listen for region update events
	document.addEventListener('msa/region-locked-products/region-update', () => {
		const currentRegion = getCookie("plaudit_msa_region_locked_products_region") || localStorage.getItem("msa/region-locked-products/region");
		updateBodyRegionClass(currentRegion);
	});
});

function getCookie(name: string) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	return parts[1]?.split(';').shift();
}
